import { lazy } from 'react';

// import AccumulatorBox from './AccumulatorBox';
// import EtageLagerBox from './EtageLagerBox';
// import LagerLongBox from './LagerLongBox';
// import LagerShortBox from './LagerShortBox';
// import StackingBox from './StackingBox';
// import RawInfeedLoadingBox from './RawInfeedLoadingBox';
// import SuperplanBox from './SuperplanBox';
// import MicrotecBox from './MicrotecBox';
// import ZincBox from './ZincBox';
// import PackageInfeedBox from './PackageInfeedBox';
// import Press from './Press';
// import ProductStackerBox from './ProductStackerBox';
// import PressBox from './PressBox';

const AccumulatorBox = lazy(() => import('./AccumulatorBox'));
const EtageLagerBox = lazy(() => import('./EtageLagerBox'));
const LagerLongBox = lazy(() => import('./LagerLongBox'));
const LagerShortBox = lazy(() => import('./LagerShortBox'));
const StackingBox = lazy(() => import('./StackingBox'));
const RawInfeedLoadingBox = lazy(() => import('./RawInfeedLoadingBox'));
const SuperplanBox = lazy(() => import('./SuperplanBox'));
const MicrotecBox = lazy(() => import('./MicrotecBox'));
const ZincBox = lazy(() => import('./ZincBox'));
const PackageInfeedBox = lazy(() => import('./PackageInfeedBox'));
const Press = lazy(() => import('./Press'));
const ProductStackerBox = lazy(() => import('./ProductStackerBox'));
const PressBox = lazy(() => import('./PressBox'));

export default {
  AccumulatorBox,
  EtageLagerBox,
  LagerLongBox,
  LagerShortBox,
  StackingBox,
  RawInfeedLoadingBox,
  SuperplanBox,
  MicrotecBox,
  ZincBox,
  PackageInfeedBox,
  Press,
  ProductStackerBox,
  PressBox
};
